import {
  GET_SCR_SETTINGS_ADJUSTMENT_TYPE_DEFINITIONS,
  GET_SCR_SETTINGS_ADJUSTMENT_TYPES,
  GET_SCR_SETTINGS_PAYMENT_TYPE_DEFINITIONS,
  GET_SCR_SETTINGS_PAYMENT_TYPES,
  PATCH_SCR_SETTINGS_ADJUSTMENT_TYPE,
  PATCH_SCR_SETTINGS_PAYMENT_TYPE,
  UPSERT_SCR_SETTINGS_ADJUSTMENT_TYPE,
  UPSERT_SCR_SETTINGS_PAYMENT_TYPE,
} from "../../../Types";

const initialState = {
  paymentTypes: [],
  adjustmentTypes: [],
  paymentTypeDefinitions: [],
  adjustmentTypeDefinitions: [],
};

const mergeTypePayload = (existing, payload) => {
  const merged = { ...existing, ...payload };
  if (
    existing &&
    !payload.definitions?.length &&
    (payload.definitionCount === 0 ||
      payload.definitionCount == null ||
      payload.definitionCount === undefined)
  ) {
    merged.definitionCount = existing.definitionCount ?? merged.definitionCount ?? 0;
  }

  return merged;
};

const upsertType = (types, payload) => {
  if (!payload?.id) {
    return types;
  }

  const index = types.findIndex((item) => item.id === payload.id);
  if (index === -1) {
    return [...types, payload].sort((left, right) =>
      (left.name || "").localeCompare(right.name || "")
    );
  }

  const next = [...types];
  next[index] = mergeTypePayload(next[index], payload);
  return next;
};

const patchDefinitionCount = (types, typeId, definitions) =>
  types.map((item) =>
    item.id === typeId
      ? {
          ...item,
          definitionCount: definitions.length,
          definitions,
        }
      : item
  );

const SCRSettingsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_SCR_SETTINGS_PAYMENT_TYPES:
      return { ...state, paymentTypes: action.payload || [] };
    case GET_SCR_SETTINGS_ADJUSTMENT_TYPES:
      return { ...state, adjustmentTypes: action.payload || [] };
    case GET_SCR_SETTINGS_PAYMENT_TYPE_DEFINITIONS: {
      const definitions = action.payload?.definitions || [];
      const typeId = action.payload?.typeId;
      return {
        ...state,
        paymentTypeDefinitions: definitions,
        paymentTypes: typeId
          ? patchDefinitionCount(state.paymentTypes, typeId, definitions)
          : state.paymentTypes,
      };
    }
    case GET_SCR_SETTINGS_ADJUSTMENT_TYPE_DEFINITIONS: {
      const definitions = action.payload?.definitions || [];
      const typeId = action.payload?.typeId;
      return {
        ...state,
        adjustmentTypeDefinitions: definitions,
        adjustmentTypes: typeId
          ? patchDefinitionCount(state.adjustmentTypes, typeId, definitions)
          : state.adjustmentTypes,
      };
    }
    case UPSERT_SCR_SETTINGS_PAYMENT_TYPE:
      return {
        ...state,
        paymentTypes: upsertType(state.paymentTypes, action.payload),
      };
    case UPSERT_SCR_SETTINGS_ADJUSTMENT_TYPE:
      return {
        ...state,
        adjustmentTypes: upsertType(state.adjustmentTypes, action.payload),
      };
    case PATCH_SCR_SETTINGS_PAYMENT_TYPE:
      return {
        ...state,
        paymentTypes: state.paymentTypes.map((item) =>
          item.id === action.payload?.id
            ? mergeTypePayload(item, action.payload)
            : item
        ),
      };
    case PATCH_SCR_SETTINGS_ADJUSTMENT_TYPE:
      return {
        ...state,
        adjustmentTypes: state.adjustmentTypes.map((item) =>
          item.id === action.payload?.id
            ? mergeTypePayload(item, action.payload)
            : item
        ),
      };
    default:
      return state;
  }
};

export default SCRSettingsReducer;
